import api from "./api";

export const getAvailableDeals =
  async () => {
    const response = await api.get(
      "DealGroups/available-deals"
    );

    return response.data;
  };

export const getDealGroups =
  async () => {
    const response = await api.get(
      "DealGroups"
    );

    return response.data;
  };

export const createDealGroup =
  async (productDealIds) => {
    const response = await api.post(
      "DealGroups",
      {
        productDealIds,
      }
    );

    return response.data;
  };

export const deleteDealGroup =
  async (dealGroupId) => {
    const response = await api.delete(
      `DealGroups/${dealGroupId}`
    );

    return response.data;
  };